import { AppointmentState } from "./type";

export const getIsAppointmentConfirmed = (state: AppointmentState) => state.isAppointmentConfirmed;



// WEBPACK FOOTER //
// ./src/store/Appointment/selectors.ts